import { Navigate, useLocation } from "react-router-dom"
import { ResultLayout } from "../components/layouts"
import {
  IEstimates,
  IQuestionValues,
  IScopeOfWorkValue,
  SCOPE_OF_WORK_MAP,
} from "../features/bpo"
import { Estimates, IEstimateParam } from "../features/bpo_result"

// WARNING: when editing this text, ensure the thank-you email sent from HubSpot workflow is edited as well
// link to email: https://app.hubspot.com/email/20462440/details/122788406668/performance
const DISCLAIMERS = [
  "※ジョーシスアウトソーシングは月額8万円からのご案内となっております。",
  "※このシミュレーション結果は、ジョーシス「有料プラン」をご利用いただいた場合を想定しております。",
  "※デバイスの購入後の配送や回収時に発生する送料なども含まれております。",
  "※情シス正社員コストは、国税庁発表「令和3年分民間給与実態統計調査」に基づき、正社員平均年収508万円を採用しております。",
]

const formatScopeOfWork = (scope_of_work: IScopeOfWorkValue[]) => {
  const formattedArray = []
  for (const x of scope_of_work) {
    const matches = SCOPE_OF_WORK_MAP.filter((obj) => x === obj.value)

    if (!matches || !matches.length) continue
    formattedArray.push(matches[0].label)
  }
  return formattedArray.join("、")
}

const BPOResult = () => {
  const location = useLocation()
  const state = location.state as {
    questionValues: IQuestionValues
    simulationResults: IEstimates
  }

  if (!state) {
    return <Navigate to="/" />
  }

  const { questionValues, simulationResults } = state
  const params: IEstimateParam[] = [
    {
      label: "ご希望のアウトソーシング業務",
      value: formatScopeOfWork(questionValues.scope_of_work),
    },
    { label: "毎月の入社数", value: `${questionValues.num_joins}人` },
    { label: "毎月の退職数", value: `${questionValues.num_leaves}人` },
    { label: "毎月の異動数", value: `${questionValues.num_transfers}人` },
    { label: "ご利用中の SaaS", value: `${questionValues.num_apps}個` },
  ]

  return (
    <ResultLayout disclaimers={DISCLAIMERS}>
      <Estimates
        results={simulationResults}
        params={params}
        px={`clamp(1.5rem, 1.35rem + 0.75vw, 2.25rem)`}
        py={`clamp(1.75rem, 1.6rem + 0.75vw, 2.5rem)`}
      />
    </ResultLayout>
  )
}
export { BPOResult }
